import classnames from 'classnames';
import React, { RefObject } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import { ResponsiveImage } from 'store/commonTypes';
import ArrowButton from './ArrowButton';
import styles from './styles.scss';

export interface Props {
  images?: ResponsiveImage[];
  containerStyle?: string;
}

export default class BoligImages extends React.Component<Props> {
  mainDiv: HTMLDivElement;

  firstClientX: number;

  firstClientY: number;

  clientX: number;

  clientY: number;

  slider: RefObject<Slider>;

  state = {
    hoverLeft: false,
    hoverRight: false,
  };

  constructor(props) {
    super(props);
    this.slider = React.createRef();
  }

  componentDidMount(): void {
    this.mainDiv.addEventListener('touchstart', this.touchStart);
    this.mainDiv.addEventListener('touchmove', this.preventTouch, { passive: false });
  }

  componentWillUnmount(): void {
    this.mainDiv.removeEventListener('touchstart', this.touchStart);
    // eslint-ignore-next-line

    this.mainDiv.removeEventListener('touchmove', this.preventTouch);
  }

  touchStart(e): void {
    this.firstClientX = e.touches[0].clientX;
    this.firstClientY = e.touches[0].clientY;
  }

  preventTouch(e): boolean {
    const minValue = 5; // threshold

    this.clientX = e.touches[0].clientX - this.firstClientX;
    this.clientY = e.touches[0].clientY - this.firstClientY;

    // Vertical scrolling does not work when you start swiping horizontally.
    if (e.cancelable && Math.abs(this.clientX) > minValue) {
      e.preventDefault();
      e.returnValue = false;
      return false;
    }
    return true;
  }

  nextSlide = (): void => {
    this.slider.current.slickNext();
  };

  prevSlide = (): void => {
    this.slider.current.slickPrev();
  };

  render(): JSX.Element {
    const { images, containerStyle } = this.props;
    const { hoverLeft, hoverRight } = this.state;
    return (
      <div
        className={classnames(styles.wrapper, containerStyle && containerStyle)}
        ref={(elem): void => {
          this.mainDiv = elem;
        }}
      >
        <div className={styles.sliderContainer}>
          {images.length > 1 && (
            <div className={styles.buttonsContainer}>
              <div
                className={styles.col}
                onClick={this.prevSlide}
                onMouseEnter={(): void => this.setState({ hoverLeft: true })}
                onMouseLeave={(): void => this.setState({ hoverLeft: false })}
              >
                <ArrowButton hoverClass={hoverLeft && styles.hoverButton} className={styles.leftButton} />
              </div>

              <div
                onMouseEnter={(): void => this.setState({ hoverRight: true })}
                onMouseLeave={(): void => this.setState({ hoverRight: false })}
                className={styles.col}
                onClick={this.nextSlide}
              >
                <ArrowButton hoverClass={hoverRight && styles.hoverButton} isRight className={styles.rightButton} />
              </div>
            </div>
          )}

          <Slider ref={this.slider} className={styles.slider} speed={300}>
            {images.map(imageObj => {
              return (
                <div key={imageObj.large} className={styles.imageContainer}>
                  <img
                    srcSet={`${imageObj.small} 414w,
                      ${imageObj.medium} 768w,
                      ${imageObj.large} 1024w`}
                    sizes="(max-width: 414px) 400px,
                      (max-width: 768px) 700px,
                      1000px"
                    src={imageObj.large}
                  />
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    );
  }
}
